import {AlunoPremiado} from "@/models/AlunoPremiado"

export default {
  nivel1: {
    ouro: [
      new AlunoPremiado('Cássio Cavalcante Colares'),
      new AlunoPremiado('Gabriel Amorim Santiago'),
      new AlunoPremiado('Maria Emília do Prado Cardoso')
    ],
    prata: [
      new AlunoPremiado('Arthur Alencar Spuri'),
      new AlunoPremiado('Caleby de Souza Cordeiro'),
      new AlunoPremiado('Eduarda Castelo Rabelo'),
      new AlunoPremiado('Enzo Holanda Sampaio'),
      new AlunoPremiado('João Vitor Veras Chaves'),
      new AlunoPremiado('Laura Oliveira Mota'),
      new AlunoPremiado('Manuella Autran do Nascimento Magalhães')
    ],
    bronze: [
      new AlunoPremiado('Ana Clara Carolino Morais'),
      new AlunoPremiado('Guilherme da Silva Colares'),
      new AlunoPremiado('Isadora Barroso Silva Lôbo'),
      new AlunoPremiado('Julia de Paula Pessoa Leguiza'),
      new AlunoPremiado('Mell Rodrigues Gerage'),
      new AlunoPremiado('Pedro Silva do Nascimento'),
      new AlunoPremiado('Valentina Vale Farias Cruz')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Alycia Trajano de Vasconcelos'),
      new AlunoPremiado('Ana Luiza Aquino Benigno de Oliveira'),
      new AlunoPremiado('Elisa Moura de Sousa Brasil'),
      new AlunoPremiado('Gabriel Mendes Freitas'),
      new AlunoPremiado('Mateus Sales Vieira Rocha Bastos'),
      new AlunoPremiado('Matheus Bezerra Walraven de Almeida'),
      new AlunoPremiado('Tiago Rocha Morais de Santiago')
    ]
  },
  nivel2: {
    ouro: [
      new AlunoPremiado('João Victor Silva dos Santos'),
      new AlunoPremiado('Levi Magalhães Pereira Castello Branco'),
      new AlunoPremiado('Matheus Alencar de Moraes')
    ],
    prata: [
      new AlunoPremiado('Caique Paiva'),
      new AlunoPremiado('João Marcelo Aragão Rosa'),
      new AlunoPremiado('Levi Félix Barbosa'),
      new AlunoPremiado('Matheus Henrique Pereira Borba'),
      new AlunoPremiado('Miguel Chianca Evangelista')
    ],
    bronze: [
      new AlunoPremiado('Alessandro Mathias Machado'),
      new AlunoPremiado('Antonio Vinícius Candeira Soeiro Moreira'),
      new AlunoPremiado('Arthur Caminha Viana Santiago Lopes'),
      new AlunoPremiado('Arthur Diniz Cabral'),
      new AlunoPremiado('Fernando Oliveira Parente'),
      new AlunoPremiado('Juliana Souza Pinho'),
      new AlunoPremiado('Letícia Felício Saldanha'),
      new AlunoPremiado('Lucas Oliveira Galindo Almeida'),
      new AlunoPremiado('Raira Lins Cruz de Moura')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Abel Duarte Brandão'),
      new AlunoPremiado('Antônio Julyano Torres de Souza Silva'),
      new AlunoPremiado('Beatriz São Leandro Cosimatti'),
      new AlunoPremiado('Filipe Ya Hu Dai Lima'),
      new AlunoPremiado('Matheus Oliveira Quintela')
    ]
  },
  nivel3: {
    ouro: [
      new AlunoPremiado('Caio Hermano Maia de Oliveira'),
      new AlunoPremiado('Davi Gabriel Bandeira Coutinho'),
      new AlunoPremiado('Gabriel Seares Dellaroli'),
      new AlunoPremiado('Yvens Ian Prado Porto')
    ],
    prata: [
      new AlunoPremiado('Alan Mesquita Rios'),
      new AlunoPremiado('Antônio Eduardo Rossano'),
      new AlunoPremiado('João Guilherme Costa Viana')
    ],
    bronze: [
      new AlunoPremiado('Caio Harley Constancio Neves'),
      new AlunoPremiado('Gabriella Santana Morgado'),
      new AlunoPremiado('João Paulo Pereira da Silva'),
      new AlunoPremiado('João Rafael Silva de Azeredo'),
      new AlunoPremiado('Ramyro Corrêa Aquines'),
      new AlunoPremiado('Tárik Ponte e Sá')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Caio Martins Temponi do Valle'),
      new AlunoPremiado('Darlan Vitor Albuquerque França'),
      new AlunoPremiado('Endy Lumy Okamura Miyashita'),
      new AlunoPremiado('Fabrícia Cardoso Marques'),
      new AlunoPremiado('Hericle de Lima de Moura'),
      new AlunoPremiado('Lucas Almeida Oliveira'),
      new AlunoPremiado('Luís Felipe de Almeida Marques'),
      new AlunoPremiado('Luis Roberto Quintanilla Torrez'),
      new AlunoPremiado('Pedro Henrique Arruda Alves')
    ]
  }
}
